/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'unarchive': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#BDC6D3" fill-rule="nonzero"><path pid="0" d="M19.994 12.47a.825.825 0 00-.047-.263l-2.5-6.667a.833.833 0 00-.78-.54h-2.5a.833.833 0 100 1.666h1.922l1.875 5h-3.797a.833.833 0 00-.833.833v1.667H6.667v-1.667a.833.833 0 00-.833-.833H2.036l1.875-5h1.923a.833.833 0 100-1.667h-2.5a.835.835 0 00-.781.541l-2.5 6.667a.824.824 0 00-.047.264c0 .01-.006.018-.006.028v6.667c0 .46.373.833.834.833h18.333c.46 0 .833-.373.833-.833v-6.667c0-.01-.006-.018-.006-.028"/><path pid="1" d="M7.5 4.166a.831.831 0 00.59-.245l1.077-1.077v7.988a.833.833 0 101.666 0V2.844l1.078 1.077a.831.831 0 001.178 0 .832.832 0 000-1.178L10.59.244a.834.834 0 00-1.18 0l-2.5 2.5a.832.832 0 00.59 1.422"/></g>'
  }
})
